import { render, staticRenderFns } from "./device_vers.vue?vue&type=template&id=30710786&"
import script from "./device_vers.vue?vue&type=script&lang=js&"
export * from "./device_vers.vue?vue&type=script&lang=js&"
import style0 from "./device_vers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports